import { FC, useEffect } from "react";
import { Controller } from "react-hook-form";
import { useI18n } from "../../hooks/useTranslations";
import Button from "../ui/Button";
import Form from "../ui/Form";
import FormField from "../ui/FormField";
import Input from "../ui/Input";
import styles from "./UpdateRequestStatusForm.module.css";

export interface UpdateRequestStatusFormBody {
  notes: string;
}
type UpdateRequestStatusFormProps = {
  onSubmit: (data: UpdateRequestStatusFormBody) => void;
  isOptional?: boolean;
  isSidebarOpen?: boolean;
};

const UpdateRequestStatusForm: FC<UpdateRequestStatusFormProps> = ({ onSubmit, isOptional = true, isSidebarOpen }) => {
  const i18n = useI18n();

  const defaultValues = {
    notes: "",
  };

  return (
    <Form<UpdateRequestStatusFormBody> defaultValues={defaultValues} mode="onSubmit">
      {({ control, reset, trigger, watch }) => {
        const submit = async () => {
          const res = await trigger();
          if (res) {
            onSubmit(watch());
            reset();
          }
        };

        useEffect(() => {
          reset(defaultValues);
        }, [isSidebarOpen]);

        return (
          <Controller
            name="notes"
            control={control}
            rules={{
              required: !isOptional,
            }}
            render={({ field, fieldState }) => (
              <FormField label={i18n.t.common.writeMessage} error={fieldState.error} isOptional={isOptional}>
                {({ labelId, isInvalid }) => (
                  <div className={styles.inline}>
                    <Input
                      id={labelId}
                      {...field}
                      isInvalid={isInvalid}
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          submit();
                        }
                      }}
                    />
                    <Button
                      buttonProps={{
                        onClick: submit,
                      }}
                    >
                      {i18n.t.common.send}
                    </Button>
                  </div>
                )}
              </FormField>
            )}
          />
        );
      }}
    </Form>
  );
};

export default UpdateRequestStatusForm;
